export default __webpack_public_path__ + "static/media/sobre_img.27b62802.webp";